module.exports = __webpack_public_path__ + "static/media/gloriaJoe90.f3065e4a.png";